// extracted by mini-css-extract-plugin
export default {"identity":"styles_identity__rEiNu","avatar":"styles_avatar__0Hwlk","name":"styles_name__GjRig","spinContainer":"styles_spinContainer__y2k3t"};